import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { housingFundsCheckList } from '../../../common/data';
import AlertButton from './AlertButton';

const HousingFundsCheckList = ({ onOpen }) => {
  const { t } = useTranslation('deductions/housingFunds');
  const checkList = housingFundsCheckList(t);
  const { s10Data } = useSelector(state => state.housingFunds);

  // 1 : 공제완료 2 : 공제불가 3 : 체크전
  const status = key => {
    if (Number(s10Data.htm013) > 70000000) {
      if (key == 'htm104') {
        return '2';
      }
      if (Number(s10Data.htm013) > 80000000) {
        if (key == 'htm105') {
          return '2';
        }
      }
    }
    return s10Data[key];
  };

  const disabled = key => {
    //총급여 7천만원 초과 근로자로 주택마련 저축 불가
    if (Number(s10Data.htm013) > 70000000) {
      if (key == 'htm104') {
        return true;
      }
      //총급여 8천만원 초과 근로자로 월세액 불가
      if (Number(s10Data.htm013) > 80000000) {
        if (key == 'htm105') {
          return true;
        }
      }
    }
    return false;
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '10px' }}>
      {checkList.map((item, index) => (
        <AlertButton
          key={index}
          {...item}
          status={status(item.key)}
          disabled={disabled(item.key)}
          onOpen={onOpen}
        />
      ))}
    </div>
  );
};

export default HousingFundsCheckList;
